<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';
  import { modals } from '$lib/stores/modals';
  import Search from '$components/Icons/Search.svelte';
  import BlockButton from '$components/Button/BlockButton.svelte';
  let button: HTMLButtonElement | undefined = $state();
  const responsiveVars = new ResponsiveVars()
    .addFluid('toggle-padding', toFluidVarInput(6, 6))
    .addFluid('icon-size', toFluidVarInput(18, 18))
    .toCSS();
</script>

<BlockButton
  motion="never"
  onclick={() => {
    modals.open('search', button);
  }}
  py={toFluidVarInput(18, 18)}
  px={toFluidVarInput(9, 9)}
  data-testid="search-modal-toggle"
  aria-label="Open search modal"
  variant="ghost"
>
  <div class={cx(responsiveVars, 'icon')}>
    <Search />
  </div>
</BlockButton>

<style lang="scss">
  .icon {
    display: flex;
    justify-content: center;
    height: var(--icon-size);
    width: var(--icon-size);
  }
</style>
